import "../../styles/CertificationsDetails.scss";
import { convertMinutesToDuration } from "../../utils/util";
import { OBJECT_ENTRY_URL_SEPARATOR } from "../../utils/constants";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useSanitizeHTML from "../../Hooks/useSanitizeHTML";
import { getLearningPathTitle } from "../../services/learning-path";
import { RELATIONSHIP_FIELD } from "../../utils/constants";

const CertificationsDetailsCard = ({ duration, title, description, learningPaths, assessmentId, url }) => {
    const { t } = useTranslation();
    const [learningPathTitles, setLearningPathTitles] = useState({});

    useEffect(() => {
        const fetchLearningPathTitles = async () => {
            const LearningPathTitlesMap = {};
            for (const learningPath of learningPaths) {
                try {
                    const response = await getLearningPathTitle(learningPath.id);
                    LearningPathTitlesMap[learningPath.id] = response.title; 
                } catch (error) {
                    console.error(`Error to fetch Learning Path title ${learningPath.id}:`, error);
                    LearningPathTitlesMap[learningPath.id] = ""; 
                }
            }
            setLearningPathTitles(LearningPathTitlesMap);
        };

        fetchLearningPathTitles();
    }, [learningPaths]);

    return (
        <div className="certifications-details-card__container">
            <div className="certifications-details-card__tag-duration">
                <p>{convertMinutesToDuration(duration, "hours")}</p>
            </div>
            <h2 className="certifications-details-card__title">{title}</h2>
            <div>
                <div className="certifications-details-card__description">
                    <p
                        dangerouslySetInnerHTML={{
                            __html: useSanitizeHTML(description),
                        }}
                    ></p>
                </div>
            </div>

            <div className="certifications-details-card__buttons">
                {learningPaths.map((learningPath) => {
                  const learningPathAssessmentId = learningPath[RELATIONSHIP_FIELD.ASSESSMENTS_IN_LEARNING_PATHS];

									if (learningPathAssessmentId > 0 && learningPathAssessmentId === assessmentId) {
										return (
												<a key={learningPath.id} href={`/${OBJECT_ENTRY_URL_SEPARATOR.LEARNING_PATH}/${learningPath.id}`} className="certifications-details-card__button-learning-path">
														{learningPathTitles[learningPath.id] || "Loading..."}&nbsp;
														{t("learning-path")}
												</a>
										);
                  }

                  return null;
                })}
                <a href={url} className="certifications-details-card__button-take">
                    <span>{t("take")} {title}</span>
                </a>
            </div>
        </div>
    );
};

export default CertificationsDetailsCard;
